import { createSlice } from "@reduxjs/toolkit";
import { InvoiceListApi, InvoiceByIdApi } from "../api/InvoiceApi"

const initState = {
    loading: false,
    resData: [],
    invoice: {}
}

export const InvoiceSlice = createSlice({
    name: "InvoiceSlice",
    initialState: initState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(InvoiceListApi.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(InvoiceListApi.fulfilled, (state, action) => {
            state.loading = false;
            state.resData = action?.payload;
        })
        builder.addCase(InvoiceListApi.rejected, (state) => {
            state.loading = false;
        })

        builder.addCase(InvoiceByIdApi.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(InvoiceByIdApi.fulfilled, (state, action) => {
            state.loading = false;
            state.invoice = action?.payload;
        })
        
        builder.addCase(InvoiceByIdApi.rejected, (state) => {
            state.loading = false;
        })
    }
})

export default InvoiceSlice.reducer
